<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
#app {
  height: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue